<template>
  <div class="d-flex align-center mb-3">
    <p class="default_txt cursor" @click="breadCrumbs">Course</p>
    <v-icon small>mdi-chevron-right</v-icon>
    <p class="small_txt ma-0 color_default cursor"><b>Class</b></p>
  </div>
</template>

<script>
export default {
  name: "breadcrumbSection",
  methods: {
    breadCrumbs() {
      this.$router.push("/course/cr/list");
    },
  },
};
</script>

<style>
</style>